export const GlassCard = ({ className = "", children, id }) => (
  <div id={id} className={`public-glass-card rounded-2xl border border-white dark:border-slate-900/70 bg-white dark:bg-slate-900/75 backdrop-blur-xl shadow-[0_12px_32px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_18px_42px_rgba(15,23,42,0.10)] ${className}`}>{children}</div>
);

export const SectionHeader = ({ k, title, desc, right }) => (
  <div className="public-section-header flex items-end justify-between gap-4 mb-4">
    <div>
      <p className="text-xs sm:text-sm uppercase tracking-wider text-indigo-600 dark:text-indigo-300 font-semibold">{k}</p>
      <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100 tracking-tight">{title}</h2>
      {desc ? <p className="mt-1 text-sm text-slate-600 dark:text-slate-400 max-w-2xl">{desc}</p> : null}
    </div>
    {right ? <div className="shrink-0">{right}</div> : null}
  </div>
);

export const Pill = ({ children }) => (
  <span className="inline-flex items-center rounded-full border border-white dark:border-slate-900/60 bg-white dark:bg-slate-900/60 px-3 py-1 text-xs font-semibold text-slate-700 dark:text-slate-300 shadow-sm">
    {children}
  </span>
);
